[
  {
    "code": "PA-1",
    "name": "Bocas del Toro"
  },
  {
    "code": "PA-4",
    "name": "Chiriquí"
  },
  {
    "code": "PA-2",
    "name": "Coclé"
  },
  {
    "code": "PA-3",
    "name": "Colón"
  },
  {
    "code": "PA-5",
    "name": "Darién"
  },
  {
    "code": "PA-EM",
    "name": "Emberá"
  },
  {
    "code": "PA-6",
    "name": "Herrera"
  },
  {
    "code": "PA-KY",
    "name": "Kuna Yala"
  },
  {
    "code": "PA-7",
    "name": "Los Santos"
  },
  {
    "code": "PA-NB",
    "name": "Ngäbe-Buglé"
  },
  {
    "code": "PA-8",
    "name": "Panamá"
  },
  {
    "code": "PA-9",
    "name": "Veraguas"
  }
]